import { Box, CircularProgress } from '@mui/material';
import { Suspense } from 'react';
import { Route } from 'react-router-dom';

/**
 * Loading fallback component for lazy-loaded routes
 */
export const LoadingFallback = () => (
  <Box
    sx={{
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
      height: '100%',
      minHeight: '400px',
    }}
  >
    <CircularProgress />
  </Box>
);

/**
 * Recursive route renderer for admin routes
 * Wraps each route element with Suspense for lazy loading
 */
export const renderAdminRoutes = (routes) => {
  return routes.map((route, index) => {
    // Use route.path as key, fallback to route.handle, then index
    const key = route.path || route.handle || `route-${index}`;
    
    const element = (
      <Suspense fallback={<LoadingFallback />}>
        {route.element}
      </Suspense>
    );

    // If this is an index route (no path, just index: true)
    if (route.index) {
      return (
        <Route
          key={key}
          index
          element={element}
        />
      );
    }

    // If route has children, render them recursively
    if (route.children && route.children.length > 0) {
      return (
        <Route key={key} path={route.path} element={element}>
          {renderAdminRoutes(route.children)}
        </Route>
      );
    }

    // Regular route with path
    return (
      <Route
        key={key}
        path={route.path}
        element={element}
      />
    );
  });
};
